// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from '../supports/dms-common';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';


function SelectListDialog2(props) {

  const { open, onClose, onSelected, iniValue } = props;

  const selectLabel = props.selectLabel || "";
  const options = props.options || [];

  const handleCloseClick = () => {
    onClose && onClose();
  }


  const handleListItemClick = (aValue) => {

    onSelected && onSelected(aValue);

    handleCloseClick();
  };

  return (

    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={handleCloseClick}
      aria-describedby="dialog-select-list"
    >
      {(selectLabel != "") &&
        <DialogTitle>{selectLabel}</DialogTitle>
      }

      <DialogContent>

        <List sx={{ pt: 0 }}>
          {options.map((item, idx) => (
            <ListItem button selected={iniValue == item.value} onClick={() => handleListItemClick(item.value)} key={idx}>
              <ListItemText primary={item.name} />
            </ListItem>
          ))}
        </List>

      </DialogContent>
    </Dialog>

  );
}

SelectListDialog2.propTypes = {
  open: PropTypes.bool,
  selectLabel: PropTypes.string,
  options: PropTypes.array,
  onSelected: PropTypes.func,
  iniValue: PropTypes.any,
  onClose: PropTypes.func,

};

export default SelectListDialog2